import axios from 'axios'

const normalizePostcodeAddress = (address) => ({
    ...address,
    line_1: address?.line_1 || '',
    line_2: address?.line_2 || '',
    line_3: address?.line_3 || '',
    line_4: '',
    locality: address?.dependant_locality || '',
    town_or_city: address?.post_town || '',
    district: address?.district || address?.post_town || address?.county || '',
    building_number: address?.building_number || '',
})

export default {
    namespaced: true,
    state: {
        postCodeList: [],
        addressList: [],
        boroughFromAddress: '',
    },
    mutations: {
        SET_POST_CODE_LIST( state, data){
            state.postCodeList = data
        },
        SET_ADDRESS_LSIT( state, data){
            state.addressList = data
        },
        SET_BOROUGH( state, data){
            state.boroughFromAddress = data
        },
    },
    actions: {
         /* eslint-disable */
        async GET_POST_CODE_LIST({ commit }, query) {
            const trimmedQuery = query?.trim()

            if (!trimmedQuery || trimmedQuery.length < 3) {
                commit('SET_POST_CODE_LIST', [])
                return
            }

            try {
                const { data } = await axios({
                    method: 'get',
                    url: `${process.env.VUE_APP_BASE_URL}address/get_postcode`,
                    params: {
                        postcode: trimmedQuery
                    }
                    // url: `https://api.ideal-postcodes.co.uk/v1/postcodes/${encodeURIComponent(trimmedQuery)}?api_key=${process.env.VUE_APP_GET_ADDRESS_KEY}`
                })

                const postcodes = [...new Set((data.result || []).map(address => address.postcode).filter(Boolean))]
                commit('SET_POST_CODE_LIST', postcodes)
            } catch (error) {
                const suggestions = error?.response?.data?.suggestions || []
                commit('SET_POST_CODE_LIST', suggestions)
            }
            
        },
        async GET_ADDRESS_LSIT({ commit }, query){
            try {
                const { data } = await axios({
                    method: 'get',
                    url: `${process.env.VUE_APP_BASE_URL}address/get_address_list`,
                    params: {
                        query
                    }
                    // url: `https://api.ideal-postcodes.co.uk/v1/postcodes/${encodeURIComponent(query)}?api_key=${process.env.VUE_APP_GET_ADDRESS_KEY}`
                })
                const addresses = (data.result || []).map(normalizePostcodeAddress)

                commit('SET_ADDRESS_LSIT', addresses);
                commit('SET_BOROUGH', addresses[0]?.district || '');
            } catch (error) {
                commit('SET_ADDRESS_LSIT', []);
                commit('SET_BOROUGH', '');
            }

        }
        
       
    },
    getters: {
        getAddresByline_1:(state) => (line) =>{
            return state.addressList.filter( list => list.line_1 == line )
        } 
        // const state = await this.$store.getters["states/getStateByCountryId"](
        //     results.id
        //   );
        
    }

}
